import React from "react";
// import { useNavigate } from "react-router-dom";


// ── Data ────────────────────────────────────────────────────
// const TRUST_BADGES = [
//   "7-day Pro trial",
//   "No credit card required",
//   "SOC 2 in progress",
//   "GDPR-aware",
// ];

const METRICS = [
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 stroke-indigo-500 fill-none stroke-2">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
        <polyline points="16 7 22 7 22 13" />
      </svg>
    ),
    value: "60%",
    title: "Reduction in rework",
    desc: "Ambiguity resolved before engineering begins.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 stroke-indigo-500 fill-none stroke-2">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 15 15" />
      </svg>
    ),
    value: "3×",
    title: "Faster requirement cycles",
    desc: "Discovery workshops compressed from weeks to hours.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 stroke-indigo-500 fill-none stroke-2">
        <circle cx="18" cy="18" r="3" />
        <circle cx="6" cy="6" r="3" />
        <path d="M13 6h3a2 2 0 0 1 2 2v7" />
        <line x1="6" y1="9" x2="6" y2="21" />
      </svg>
    ),
    value: "100%",
    title: "End-to-end traceability",
    desc: "Every requirement linked to source, design, and tests.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" className="w-5 h-5 stroke-indigo-500 fill-none stroke-2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
      </svg>
    ),
    value: "Audit",
    title: "-ready by default",
    desc: "Versioned, attributed, and compliance-exportable.",
  },
];

// ── Component ────────────────────────────────────────────────
const DeliveryAILanding = () => {
    // const navigate = useNavigate();
  return (
    <div className="font-sans">

      {/* ── HERO ── */}
      <section className="bg-white text-center px-6 py-20 lg:py-24">
        <h1 className="text-5xl lg:text-6xl  text-[#0d1b2e] leading-tight">
          AI Agent for
          <br />
          <span className="text-[#2e7eed]">Smarter Project Delivery.</span>
        </h1>

        <p className="mt-5 text-base lg:text-lg text-gray-500 leading-relaxed max-w-xl mx-auto">
          DeliveryAI helps teams convert project updates, meeting notes, risks,
          and delivery signals into clear actions, summaries, and execution
          insights — with end-to-end traceability from day one.
        </p>

        {/* Buttons */}
        {/* <div className="mt-9 flex items-center justify-center gap-4 flex-wrap">
          <button
          onClick={() =>
    window.open("https://deliveryai.axtelica.com", "_blank")
  }
           className="flex items-center gap-2 bg-[#2e7eed] hover:bg-[#1b66d6] text-white  text-sm px-7 py-3.5 rounded-xl transition-all duration-200 hover:-translate-y-0.5">
            Start Free Trial
            <svg viewBox="0 0 16 16" className="w-4 h-4" fill="none">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <button
          onClick={() => navigate("/demo")}
           className="flex items-center bg-white border-2 border-gray-200 hover:border-gray-400 text-[#0d1b2e] text-sm px-7 py-3.5 rounded-xl transition-all duration-200">
            Request Demo
          </button>
        </div> */}

        {/* Trust badges */}
        {/* <div className="mt-5 flex items-center justify-center gap-1.5 flex-wrap">
          {TRUST_BADGES.map((badge, i) => (
            <React.Fragment key={badge}>
              <span className="text-xs text-gray-400">{badge}</span>
              {i < TRUST_BADGES.length - 1 && (
                <span className="text-gray-300 text-xs">·</span>
              )}
            </React.Fragment>
          ))}
        </div> */}
      </section>

      {/* ── METRICS ── */}
      <section className="bg-[#f8f9fc] px-6 py-10 lg:py-16">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-[11px] tracking-[2px] uppercase text-indigo-500 mb-4">
            Business Impact
          </p>
          <h2 className="text-3xl lg:text-4xl  text-[#0d1b2e] leading-snug">
            Measurable outcomes across the enterprise.
          </h2>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {METRICS.map((card) => (
            <div
              key={card.title}
              className="bg-white border border-gray-200 rounded-2xl p-7 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg cursor-default"
            >
              {/* Icon */}
              <div className="w-11 h-11 rounded-xl bg-indigo-50 flex items-center justify-center mb-5">
                {card.icon}
              </div>

              {/* Value */}
              <div className="text-4xl  text-[#0d1b2e] leading-none mb-1.5">
                {card.value}
              </div>

              {/* Title */}
              <div className="text-sm  text-[#0d1b2e] mb-2">
                {card.title}
              </div>

              {/* Description */}
              <div className="text-sm text-gray-500 leading-relaxed">
                {card.desc}
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default DeliveryAILanding;